import { useState } from "react";
import { api } from "../api";
import { Button } from "./tailwind/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "./tailwind/dialog";

const DialogDeleteSegment = ({ segment, isModalOpen, onClose, onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = async () => {
    if (!segment) return;

    setIsLoading(true);

    try {
      await api.archiveSegment({
        segmentId: segment.id,
      });

      if (onSuccess) {
        onSuccess(segment);
      }

      onClose();
    } catch (error) {
      console.error("Error archiving segment:", error);
      // You might want to show an error message to the user here
    } finally {
      setIsLoading(false);
    }
  };

  if (!segment) return null;

  return (
    <Dialog key="dialog_delete_segment" open={isModalOpen} onClose={onClose}>
      <DialogTitle>Delete Segment</DialogTitle>
      <DialogBody className="flex-1 overflow-y-auto scrollbar">
        <p className="mb-4">
          Are you sure you want to delete the segment{" "}
          <strong>"{segment.name}"</strong>?
        </p>
        <div className="my-4 p-3 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm text-red-800">
            <strong>Warning:</strong> This action cannot be undone. The segment
            will be permanently removed from your account.
          </p>
        </div>
      </DialogBody>
      <DialogActions>
        <Button
          color="secondaryButton"
          onClick={onClose}
          disabled={isLoading}
          className="min-w-[100px] h-10"
        >
          Cancel
        </Button>
        <Button
          color="primaryButton"
          onClick={handleDelete}
          className="min-w-[100px] h-10"
          loading={isLoading}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogDeleteSegment;
